import { Crud } from ".";
import { getIsReadParam, getSearchParam } from "../hooks/paramsHelpers";

export class UserMessagesApi extends Crud {
    constructor() {
        super('admin_user_messages')
    }
    async get(listContext, ...args) {
        listContext = JSON.parse(JSON.stringify(listContext));
        listContext.filter = {
            search: getSearchParam(),
            is_read: getIsReadParam(),
        }
        return await super.get(listContext, ...args);
    }
    async setReadStatus(id, is_read) {
        return await this.query('setReadStatus', 'post', { id, is_read });
    }
}
